module.exports = __webpack_public_path__ + "static/img/医疗卡片3_初始状态@2x.7e16baf0.png";